"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearingInputState = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const i18n_1 = require("../../i18n");
const number_input_state_1 = require("./number.input.state");
class BearingInputState extends number_input_state_1.NumberInputState {
    static equal(value1, value2) {
        const deg1 = core_shared_1.IkeAngle.toDegrees(value1);
        const deg2 = core_shared_1.IkeAngle.toDegrees(value2);
        return number_input_state_1.NumberInputState.equal(deg1, deg2, BearingInputState.DEGREE_PRECISION);
    }
    constructor(label) {
        super(label);
        this.precision = BearingInputState.DEGREE_PRECISION;
        this.isLabelShown = false;
    }
    formatInputValue(val) {
        const deg = core_shared_1.IkeAngle.toDegrees(val);
        return deg != null && !isNaN(deg) ? String(core_shared_1.IkeUnit.round(deg, this.precision)) : null;
    }
    parseInputValue(val) {
        const num = this.parseNumber(val);
        if (num == null) {
            this.setError(null);
            return null;
        }
        if (isNaN(num)) {
            this.setError(i18n_1.T.NUMBER_INVALID);
            return null;
        }
        this.setError(null);
        return core_shared_1.IkeAngle.toRadians(num);
    }
    parseNumber(val) {
        const RE_NUMBER = /^[+-]?((\.\d+)|(\d+(\.\d+)?))$/;
        if (val.trim().length === 0) {
            return null;
        }
        const lastChar = val.slice(-1);
        if (lastChar === '.') {
            val = val.slice(0, -1);
        }
        if (val.match(RE_NUMBER) == null) {
            return NaN;
        }
        return Number(val);
    }
}
exports.BearingInputState = BearingInputState;
BearingInputState.DEGREE_PRECISION = 2;
//# sourceMappingURL=bearing.input.state.js.map